export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="w-full lg:w-1/2">
            <div className="rounded-[2rem] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20art%20with%20flowing%20lines%20and%20nodes%20representing%20connected%20information%20network%2C%20warm%20terracotta%20and%20sand%20color%20gradient%20background%2C%20modern%20infographic%20style%2C%20elegant%20minimalist%20digital%20dashboard%20concept%2C%20soft%20diffused%20lighting%2C%20clean%20geometric%20composition%2C%20professional%20corporate%20aesthetic&width=800&height=600&seq=about-img-v2-002&orientation=squarish"
                alt="ACBuySpreadsheet order tracking system with structured data visualization and comparison analytics"
                title="ACBuySpreadsheet System - Structured Order Tracking"
                className="w-full h-auto"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
              ACBuy Spreadsheet System
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Why ACBuy<span className="font-light italic">Spreadsheet</span>?
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              ACBuySpreadsheet is a centralized spreadsheet-based system designed to simplify how users manage ACBuy orders, track shipping data, and compare pricing structures efficiently. Unlike traditional manual methods where buyers juggle multiple notes and scattered records, the ACBuy spreadsheet system centralizes every piece of information into one organized, data-driven format.
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
              Whether you are a frequent buyer sourcing products across categories — from <strong>Shoes</strong> and <strong>Hoodies</strong> to <strong>Accessories</strong> and <strong>Bags</strong> — or a reseller managing bulk orders, the ACBuySpreadsheet methodology transforms how you approach purchasing by replacing guesswork with structured data.
            </p>

            <div className="grid grid-cols-2 gap-3 mt-6 max-w-lg">
              {[
                { icon: "ri-checkbox-circle-line", text: "Reduce manual tracking errors" },
                { icon: "ri-scales-line", text: "Compare agents & shipping costs" },
                { icon: "ri-eye-line", text: "Improve order transparency" },
                { icon: "ri-bar-chart-box-line", text: "Optimize bulk purchasing" },
              ].map((item) => (
                <div key={item.text} className="flex items-start gap-2.5">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className={`${item.icon} text-accent-600 text-sm`}></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-700">{item.text}</span>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 px-5 py-3 bg-secondary-100 text-foreground-900 rounded-lg text-sm font-semibold hover:bg-secondary-200 transition-colors whitespace-nowrap"
            >
              Explore ACBuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}